import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  IconButton,
  Chip,
  Avatar,
  Box,
  Typography,
  Card,
  CardContent,
  Stack,
} from '@mui/material';
import { Edit, UserPlus } from 'lucide-react';
import { users } from '../../data/sampleData';

interface UsersListProps {
  onUserEdit: (user: any) => void;
  onAddUser: () => void;
  isMobile: boolean;
}

export const UsersList: React.FC<UsersListProps> = ({
  onUserEdit,
  onAddUser,
  isMobile,
}) => {
  const UserCard = ({ user }: { user: typeof users[0] }) => (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Stack spacing={2}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Avatar src={user.avatar} alt={user.name} />
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                {user.name}
              </Typography>
              <Typography variant="body2" color="text.secondary" noWrap>
                {user.email}
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Chip
              label={user.role}
              color={
                user.role === 'lawyer' ? 'primary' :
                user.role === 'paralegal' ? 'secondary' :
                user.role === 'partner' ? 'success' :
                'default'
              }
              size="small"
            />
            <IconButton
              size="small"
              onClick={() => onUserEdit(user)}
            >
              <Edit size={18} />
            </IconButton>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );

  return (
    <>
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'flex-end', 
        mb: 3,
      }}>
        <Button
          variant="contained"
          startIcon={<UserPlus />}
          onClick={onAddUser}
          fullWidth={isMobile}
        >
          Add User
        </Button>
      </Box>

      {isMobile ? (
        <Box>
          {users.map((user) => (
            <UserCard key={user.id} user={user} />
          ))}
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>User</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Role</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((user) => (
                <TableRow key={user.id} hover>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Avatar src={user.avatar} alt={user.name} />
                      <Typography>{user.name}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>
                    <Chip
                      label={user.role}
                      color={
                        user.role === 'lawyer' ? 'primary' :
                        user.role === 'paralegal' ? 'secondary' :
                        user.role === 'partner' ? 'success' :
                        'default'
                      }
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    <Chip
                      label="Active"
                      color="success"
                      size="small"
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell align="right">
                    <IconButton
                      size="small"
                      onClick={() => onUserEdit(user)}
                    >
                      <Edit size={18} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};